<template>
  <div :class="$route.meta.outerClass" id="app" class="vue-port-body">
    <header-part v-if="showHeader" class="header-vue"></header-part>
    <all-svg></all-svg>
    <!-- <div ref="routerview" v-if="showHeader"><router-view /></div> -->
    <router-view v-show="!appState.showVuePopup"/>
    <!-- <router-view v-else/> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      userInfo: null
    }
  },
  // watch: {
  //   'appState.showVuePopup'(from, to) {
  //     if (this.$refs.routerview.children.length > 0 ){
  //       const element = this.$refs.routerview.children[0]
  //       this.appState.routerViewHeight = element.clientHeight
  //       this.appState.routerViewWidth = element.clientWidth
  //     }
  //   }
  // },
  computed: {
    'showHeader' () {
      if (this.$router && this.$route) {
        // let currentRoute = this.$route.path
        const routes = this.$router.options.routes
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].meta && !routes[i].meta.hideHeader) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style src="element-ui/lib/theme-chalk/index.css"></style>
<style lang="scss" src="./assets/app.scss"></style>
